@for (widget of componentWidgets(); track widget.uniqueId) {
  <tt-compare-component-widget [widget]="widget" />
}
